import map from 'lodash/map';
import { Button, Spinner } from '@celltrak/ui-components';

import { text } from '../../constants';

import styles from './AgenciesCreationForm.module.scss';
import useAgenciesCreationForm from './useAgenciesCreationForm';

const AgenciesCreationForm = () => {
  const { createFieldContainer, fields, handleCancel, handleCreate, isSaveDisabled, isLoading } =
    useAgenciesCreationForm();

  const renderSpinner = () => (
    <div className={styles.spinner}>
      <Spinner color="primary">{text.creating}</Spinner>
    </div>
  );

  const renderForm = () => (
    <div className={styles.createForm}>
      <div>{map(fields, createFieldContainer)}</div>
      <div className={styles.actions}>
        <Button color="light" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleCreate} disabled={isSaveDisabled}>
          Create
        </Button>
      </div>
    </div>
  );

  return isLoading ? renderSpinner() : renderForm();
};

export default AgenciesCreationForm;
